'use strict';var getApiHost = require('./utils/getApiHost');

var isProduction = process.env.NODE_ENV === 'production';

var isDev = process.env.DEPLOYMENT_TYPE === 'dev';

var appName = 'Dragon';

var appID = isProduction ?
'1745227509067517' :
'1754080181515583';

var meta = [
{ name: 'description', content: 'פשוט לחפש בית' },
{ charset: 'utf-8' },
{ property: 'fb:app_id', content: appID },
{ property: 'og:type', content: 'website' },
{ property: 'og:site_name', content: 'OnMap' },
{ property: 'og:locale', content: 'he_IL' },
{ property: 'og:title', content: 'OnMap' },
{ property: 'og:description', content: 'פשוט לחפש בית' },
{ property: 'og:card', content: 'summary' },
{ property: 'og:site', content: '@onmap' },
{ property: 'og:creator', content: '@onmap' },
{ property: 'og:url', content: process.env.HOST || 'localhost' },
{ property: 'og:image', content: 'http://res.cloudinary.com/onmap-prod/image/upload/w_600,h_315/v1516886360/general/logo/social.png' },
{ property: 'og:image:width', content: '600' },
{ property: 'og:image:height', content: '315' }].concat(
isDev ? [{ name: 'robots', content: 'noindex,nofollow' }] : []);


var config = {
  appName: appName,
  isProduction: isProduction,
  targetApi: getApiHost(),
  host: process.env.HOST || 'http://localhost:' + process.env.PORT,
  port: process.env.PORT || 8000,
  app: {
    title: 'OnMap',
    description: 'פשוט לחפש בית',
    head: { meta: meta } } };



module.exports = config;


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 567
// module chunks = 0